import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { TrackingLocation } from '@tracking';

import EventShowPageContent from './EventShowPageContent';
import EventSubscribeModule from './EventSubscribeModule';
import { EventShowPageProps } from './interfaces';

const queryClient = new QueryClient();

const EventShowPage = ({
  event,
  eventOffer,
  upgradeOffer,
  initialCurrentUser,
  env,
  isGdprRequired,
  isWebview,
}: EventShowPageProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.EventsShowPage,
  });

  return (
    <AppContextProvider
      env={env}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
      initialCurrentUser={initialCurrentUser}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <EventShowPageContent
            event={event}
            eventOffer={eventOffer}
            upgradeOffer={upgradeOffer}
            currentUser={initialCurrentUser}
          />
          <EventSubscribeModule isSubscriber={event.isCurrentUserSubscriber} />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default EventShowPage;
